import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { academyLogin } from "@/api/academyAuth";

export default function AcademyLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);
    
    try {
      await academyLogin({ email, password });
      navigate("/academy-admin", { replace: true });
    } catch {
      setError("بيانات الدخول غير صحيحة");
    } finally {
      setIsLoading(false);
    }
  };

  // تنسيقات CSS مدمجة
  const styles = {
    container: {
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
      padding: "20px",
      direction: "rtl",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
    },
    card: {
      backgroundColor: "white",
      borderRadius: "20px",
      boxShadow: "0 15px 35px rgba(50, 50, 93, 0.1), 0 5px 15px rgba(0, 0, 0, 0.07)",
      width: "100%",
      maxWidth: "450px",
      overflow: "hidden",
      padding: "40px",
      position: "relative"
    },
    cardBefore: {
      content: '""',
      position: "absolute",
      top: "0",
      right: "0",
      width: "100%",
      height: "5px",
      background: "linear-gradient(90deg, #4b6cb7 0%, #182848 100%)"
    },
    logo: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginBottom: "30px"
    },
    logoIcon: {
      width: "70px",
      height: "70px",
      background: "linear-gradient(135deg, #4b6cb7 0%, #182848 100%)",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: "15px"
    },
    logoTitle: {
      margin: "0",
      color: "#182848",
      fontSize: "28px",
      fontWeight: "700"
    },
    form: {
      width: "100%"
    },
    title: {
      margin: "0 0 10px 0",
      color: "#182848",
      fontSize: "24px",
      fontWeight: "600",
      textAlign: "center"
    },
    subtitle: {
      color: "#6c757d",
      textAlign: "center",
      marginBottom: "30px",
      fontSize: "15px"
    },
    formGroup: {
      marginBottom: "25px"
    },
    label: {
      display: "block",
      marginBottom: "8px",
      color: "#495057",
      fontWeight: "500",
      fontSize: "15px"
    },
    inputContainer: {
      position: "relative"
    },
    inputIcon: {
      position: "absolute",
      right: "15px",
      top: "50%",
      transform: "translateY(-50%)",
      width: "20px",
      height: "20px",
      color: "#6c757d",
      zIndex: "1"
    },
    input: {
      width: "100%",
      padding: "15px 50px 15px 15px",
      border: "1px solid #e1e5eb",
      borderRadius: "10px",
      fontSize: "16px",
      transition: "all 0.3s",
      backgroundColor: "#f8f9fa",
      boxSizing: "border-box",
      fontFamily: "inherit"
    },
    inputFocus: {
      outline: "none",
      borderColor: "#4b6cb7",
      boxShadow: "0 0 0 3px rgba(75, 108, 183, 0.1)",
      backgroundColor: "white"
    },
    passwordHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "8px"
    },
    forgotPassword: {
      color: "#4b6cb7",
      fontSize: "14px",
      textDecoration: "none",
      transition: "color 0.2s",
      cursor: "pointer"
    },
    button: {
      width: "100%",
      padding: "16px",
      background: "linear-gradient(90deg, #4b6cb7 0%, #182848 100%)",
      color: "white",
      border: "none",
      borderRadius: "10px",
      fontSize: "17px",
      fontWeight: "600",
      cursor: "pointer",
      transition: "all 0.3s",
      marginTop: "10px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: "10px",
      fontFamily: "inherit"
    },
    buttonHover: {
      transform: "translateY(-2px)",
      boxShadow: "0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08)"
    },
    buttonDisabled: {
      opacity: "0.7",
      cursor: "not-allowed"
    },
    spinner: {
      width: "20px",
      height: "20px",
      border: "2px solid rgba(255, 255, 255, 0.3)",
      borderRadius: "50%",
      borderTopColor: "white",
      animation: "spin 1s ease-in-out infinite"
    },
    error: {
      backgroundColor: "#fff5f5",
      border: "1px solid #feb2b2",
      color: "#c53030",
      padding: "15px",
      borderRadius: "10px",
      marginTop: "20px",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      fontSize: "15px"
    },
    registerLink: {
      textAlign: "center",
      marginTop: "25px",
      color: "#6c757d",
      fontSize: "15px"
    },
    registerLinkAnchor: {
      color: "#4b6cb7",
      fontWeight: "600",
      textDecoration: "none",
      transition: "color 0.2s",
      cursor: "pointer"
    },
    copyright: {
      textAlign: "center",
      marginTop: "30px",
      color: "#adb5bd",
      fontSize: "13px",
      paddingTop: "20px",
      borderTop: "1px solid #e9ecef"
    },
    // أنماط للعناصر التفاعلية
    "@keyframes spin": {
      to: { transform: "rotate(360deg)" }
    }
  };

  // أيقونات SVG
  const EmailIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={styles.inputIcon}>
      <path d="M1.5 8.67v8.58a3 3 0 003 3h15a3 3 0 003-3V8.67l-8.928 5.493a3 3 0 01-3.144 0L1.5 8.67z" />
      <path d="M22.5 6.908V6.75a3 3 0 00-3-3h-15a3 3 0 00-3 3v.158l9.714 5.978a1.5 1.5 0 001.572 0L22.5 6.908z" />
    </svg>
  );

  const PasswordIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={styles.inputIcon}>
      <path fillRule="evenodd" d="M12 1.5a5.25 5.25 0 00-5.25 5.25v3a3 3 0 00-3 3v6.75a3 3 0 003 3h10.5a3 3 0 003-3v-6.75a3 3 0 00-3-3v-3c0-2.9-2.35-5.25-5.25-5.25zm3.75 8.25v-3a3.75 3.75 0 10-7.5 0v3h7.5z" clipRule="evenodd" />
    </svg>
  );

  const ErrorIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{width: "20px", height: "20px", flexShrink: 0}}>
      <path fillRule="evenodd" d="M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z" clipRule="evenodd" />
    </svg>
  );

  const AcademyIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{width: "40px", height: "40px", color: "white"}}>
      <path d="M11.7 2.805a.75.75 0 01.6 0A60.65 60.65 0 0122.83 8.72a.75.75 0 01-.231 1.337 49.949 49.949 0 00-9.902 3.912.75.75 0 01-.584 0A49.87 49.87 0 002 9.268a.75.75 0 01-.231-1.337A60.653 60.653 0 0111.7 2.805z" />
      <path d="M13.06 15.473a48.45 48.45 0 017.666-3.282c.134 1.414.22 2.843.255 4.285a.75.75 0 01-.46.71 47.878 47.878 0 00-8.105 4.342.75.75 0 01-.832 0 47.877 47.877 0 00-8.104-4.342.75.75 0 01-.461-.71c.035-1.442.121-2.87.255-4.286A48.4 48.4 0 016 13.18v1.27a1.5 1.5 0 00-.14 2.508c-.09.38-.222.753-.397 1.11.452.213.901.434 1.346.661a6.729 6.729 0 00.551-1.608 1.5 1.5 0 00.14-2.67v-.645a48.549 48.549 0 013.44 1.668 2.25 2.25 0 002.12 0z" />
      <path d="M4.462 19.462c.42-.419.753-.89 1-1.394.453.213.902.434 1.347.661a6.743 6.743 0 01-1.286 1.794.75.75 0 11-1.06-1.06z" />
    </svg>
  );

  // دالة للتعامل مع التركيز على الحقول
  const handleInputFocus = (e) => {
    e.target.style.outline = "none";
    e.target.style.borderColor = "#4b6cb7";
    e.target.style.boxShadow = "0 0 0 3px rgba(75, 108, 183, 0.1)";
    e.target.style.backgroundColor = "white";
  };

  const handleInputBlur = (e) => {
    e.target.style.borderColor = "#e1e5eb";
    e.target.style.boxShadow = "none";
    e.target.style.backgroundColor = "#f8f9fa";
  };

  // دالة للتعامل مع hover على الزر
  const handleButtonMouseEnter = (e) => {
    if (!isLoading) {
      e.target.style.transform = "translateY(-2px)";
      e.target.style.boxShadow = "0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08)";
    }
  };

  const handleButtonMouseLeave = (e) => {
    if (!isLoading) {
      e.target.style.transform = "translateY(0)";
      e.target.style.boxShadow = "none";
    }
  };

  const handleButtonMouseDown = (e) => {
    if (!isLoading) {
      e.target.style.transform = "translateY(0)";
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        {/* الخط العلوي المميز */}
        <div style={styles.cardBefore}></div>
        
        {/* شعار الأكاديمية */}
        <div style={styles.logo}>
          <div style={styles.logoIcon}>
            <AcademyIcon />
          </div>
          <h1 style={styles.logoTitle}>الأكاديمية</h1>
        </div>

        <form onSubmit={submit} style={styles.form}>
          <h2 style={styles.title}>تسجيل دخول الأكاديمية</h2>
          <p style={styles.subtitle}>أدخل بيانات الاعتماد الخاصة بك للوصول إلى لوحة التحكم</p>

          {/* حقل البريد الإلكتروني */}
          <div style={styles.formGroup}>
            <label htmlFor="email" style={styles.label}>البريد الإلكتروني</label>
            <div style={styles.inputContainer}>
              <EmailIcon />
              <input
                id="email"
                type="email"
                placeholder="example@academy.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onFocus={handleInputFocus}
                onBlur={handleInputBlur}
                required
                dir="ltr"
                style={styles.input}
              />
            </div>
          </div>

          {/* حقل كلمة المرور */}
          <div style={styles.formGroup}>
            <div style={styles.passwordHeader}>
              <label htmlFor="password" style={styles.label}>كلمة المرور</label>
              <a 
                href="#" 
                style={styles.forgotPassword}
                onClick={(e) => {
                  e.preventDefault();
                  // يمكن إضافة وظيفة استعادة كلمة المرور هنا
                  alert("وظيفة استعادة كلمة المرور قريباً!");
                }}
              >
                نسيت كلمة المرور؟
              </a>
            </div>
            <div style={styles.inputContainer}>
              <PasswordIcon />
              <input
                id="password"
                type="password"
                placeholder="أدخل كلمة المرور"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onFocus={handleInputFocus}
                onBlur={handleInputBlur}
                required
                style={styles.input}
              />
            </div>
          </div>

          {/* زر الدخول */}
          <button 
            type="submit" 
            style={{
              ...styles.button,
              ...(isLoading ? styles.buttonDisabled : {})
            }}
            disabled={isLoading}
            onMouseEnter={handleButtonMouseEnter}
            onMouseLeave={handleButtonMouseLeave}
            onMouseDown={handleButtonMouseDown}
          >
            {isLoading ? (
              <>
                <div style={styles.spinner}></div>
                جاري الدخول...
              </>
            ) : (
              "دخول"
            )}
          </button>

          {/* رسالة الخطأ */}
          {error && (
            <div style={styles.error}>
              <ErrorIcon />
              {error}
            </div>
          )}

          {/* رابط التسجيل إذا لم يكن لديك حساب */}
          <div style={styles.registerLink}>
            ليس لديك حساب؟{" "}
            <a 
              href="/academy-register" 
              style={styles.registerLinkAnchor}
              onClick={(e) => {
                e.preventDefault();
                // يمكن إضافة التنقل إلى صفحة التسجيل هنا
                alert("صفحة إنشاء حساب الأكاديمية قريباً!");
              }}
            >
              إنشاء حساب أكاديمية
            </a>
          </div>
        </form>

        {/* حقوق النشر */}
        <div style={styles.copyright}>
          © {new Date().getFullYear()} نظام إدارة الأكاديمية. جميع الحقوق محفوظة.
        </div>
      </div>

      {/* إضافة أنيميشن الـ spinner في head افتراضياً */}
      <style>{`
        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }
        
        @media (max-width: 576px) {
          .academy-login-card {
            padding: 30px 20px;
          }
          
          .academy-logo h1 {
            font-size: 24px;
          }
          
          .academy-login-form h2 {
            font-size: 22px;
          }
          
          .input-with-icon input {
            padding: 13px 45px 13px 13px;
            font-size: 15px;
          }
        }
      `}</style>
    </div>
  );
}